var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.9746H2C1.72667 14.9746 1.5 14.7479 1.5 14.4746C1.5 14.2013 1.72667 13.9746 2 13.9746H14C14.2733 13.9746 14.5 14.2013 14.5 14.4746C14.5 14.7479 14.2733 14.9746 14 14.9746Z",
    fill: "#000014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6799 2.62902C11.3866 1.33569 10.1199 1.30236 8.79322 2.62902L7.98655 3.43569C7.91989 3.50236 7.89322 3.60902 7.91989 3.70236C8.42655 5.46902 9.83989 6.88236 11.6066 7.38902C11.6332 7.39569 11.6599 7.40236 11.6866 7.40236C11.7599 7.40236 11.8266 7.37569 11.8799 7.32236L12.6799 6.51569C13.3399 5.86236 13.6599 5.22902 13.6599 4.58902C13.6666 3.92902 13.3466 3.28902 12.6799 2.62902Z",
    fill: "#000014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4066 7.99513C10.2132 7.9018 10.0266 7.80846 9.84655 7.7018C9.69989 7.61513 9.55989 7.5218 9.41989 7.4218C9.30655 7.34846 9.17322 7.2418 9.04655 7.13513C9.03322 7.12846 8.98655 7.08846 8.93322 7.03513C8.71322 6.84846 8.46655 6.60846 8.24655 6.3418C8.22655 6.32846 8.19322 6.2818 8.14655 6.2218C8.07989 6.1418 7.96655 6.00846 7.86655 5.85513C7.78655 5.75513 7.69322 5.60846 7.60655 5.4618C7.49989 5.2818 7.40655 5.1018 7.31322 4.91513C7.19085 4.6529 6.84668 4.57501 6.64206 4.77962L2.89322 8.52846C2.80655 8.61513 2.72655 8.7818 2.70655 8.89513L2.34655 11.4485C2.27989 11.9018 2.40655 12.3285 2.68655 12.6151C2.92655 12.8485 3.25989 12.9751 3.61989 12.9751C3.69989 12.9751 3.77989 12.9685 3.85989 12.9551L6.41989 12.5951C6.53989 12.5751 6.70655 12.4951 6.78655 12.4085L10.5416 8.65344C10.7421 8.45291 10.6668 8.10789 10.4066 7.99513Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.11749612823c9ede2dcf6d78b05da71e.svg";
export { ForwardRef as ReactComponent };